export const toyStore = {
  cols: ["Store", "0-2", "3-5", "6-8", "9-10", "Totals"],
  rows: [
    {
      Store: "Toy Store",
      "0-2": 275,
      "3-5": 314,
      "6-8": 343,
      "9-10": 246,
      Totals: 1178,
    },
    {
      Store: "Home Delivery",
      "0-2": 1,
      "3-5": 1,
      "6-8": 1,
      "9-10": 4,
      Totals: 7,
    },
    {
      Store: "2018 Totals",
      "0-2": 276,
      "3-5": 315,
      "6-8": 344,
      "9-10": 250,
      Totals: 1185,
    },
  ],
}
